import R from 'app/assets/R'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { IFilterAccountList } from '../../type'
import { useGetPermissionList } from 'app/react-query/hook/role'
import { groupPermissionsByModule, usePagination } from 'app/hook'
import { IPermission } from 'app/api/role/model'
import { BaseSelect } from 'app/components/common/selects/BaseSelect'
import {
  DefinePermissionEnum,
  DefinePermissionModuleEnum,
} from 'app/api/role/constant'

interface IProps {
  onChangeFilter?: (filter: IFilterAccountList) => void
  filter?: IFilterAccountList
}

export const FilterLayout: React.FC<IProps> = ({ filter, onChangeFilter }) => {
  const { t } = useTranslation()

  const onChangeSearch = (value: string) => {
    onChangeFilter?.({ ...filter, search: value })
  }

  const onChangePermissionIds = (permissionIds: number[]) => {
    onChangeFilter?.({ ...filter, permissionIds })
  }

  const { data: dataPermission, isLoading: isLoadingPermission } =
    useGetPermissionList()

  const { flattenDataList } = usePagination()

  const permissions: IPermission[] = useMemo(() => {
    return flattenDataList(dataPermission)?.data
  }, [dataPermission])

  const permissionGroup = useMemo(() => {
    return groupPermissionsByModule(permissions ?? [])
  }, [permissions])

  return (
    <BaseForm>
      <BaseRow gutter={[16, 8]}>
        <BaseCol xl={6}>
          <BaseForm.Item hiddenLabel>
            <BaseInput
              placeholder={t(R.strings.search_by_name_description)}
              value={filter?.search}
              onChange={e => onChangeSearch?.(e?.target?.value)}
              allowClear
            />
          </BaseForm.Item>
        </BaseCol>

        <BaseCol xl={12}>
          <BaseForm.Item hiddenLabel>
            <BaseSelect
              placeholder={t(R.strings.select_permission)}
              showSearch
              loading={isLoadingPermission}
              mode="multiple"
              maxTagCount={2}
              options={permissionGroup?.map(item => ({
                label: item?.module
                  ? t(DefinePermissionModuleEnum?.[item?.module]?.keyI18n)
                  : item?.module,
                options: item?.permissions?.map(item => ({
                  label: item?.permission
                    ? t(DefinePermissionEnum?.[item?.permission]?.keyI18n)
                    : item?.name,
                  value: item?.id,
                })),
              }))}
              filterSort={() => 0}
              onChange={ids => onChangePermissionIds(ids as number[])}
            />
          </BaseForm.Item>
        </BaseCol>
      </BaseRow>
    </BaseForm>
  )
}
